import { render } from "./PlayerScore.vue?vue&type=template&id=30c57693&scoped=true"
import script from "./PlayerScore.vue?vue&type=script&lang=js"
export * from "./PlayerScore.vue?vue&type=script&lang=js"

import "./PlayerScore.vue?vue&type=style&index=0&id=30c57693&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c57693"]])

export default __exports__